import { Grid, Typography } from '@mui/material';
import moment from 'moment';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomButton } from '../../../../../components';
import { createEventApplication } from '../../../../../core/vendor-events/action';
import { formatDate } from '../../../../../utils';
import CheckIcon from '../../../vendor-event-guide/components/CheckIcon';

export default function DeniedPage() {
  const dispatch = useDispatch();
  const { currentVendorEvent } = useSelector((store) => store.vendorEvents);

  const expectedApplicationDate = useMemo(() => {
    const date = moment(currentVendorEvent.last_application_date);
    date.add(3, 'days');
    return date;
  }, [currentVendorEvent]);

  const sendApplication = () => {
    dispatch(
      createEventApplication({
        eventId: currentVendorEvent.fk_event,
        vendorId: currentVendorEvent.fk_vendor,
      }),
    );
  };

  return (
    <div>
      <Grid container justifyContent="center" marginY={2}>
        <CheckIcon />
        <Typography>The venue did not approve your application</Typography>
      </Grid>
      <Grid container justifyContent="center">
        <Grid item>
          <Typography fontWeight="bold">Reminder:</Typography>
        </Grid>
        <Grid item>
          <Typography marginLeft={2}>
            You can apply again on {formatDate(expectedApplicationDate)}
          </Typography>
        </Grid>
        <Grid item xs={12} mt={6} paddingX={32}>
          <CustomButton
            variant="contained"
            disabled={!moment().isAfter(expectedApplicationDate)}
            onClick={sendApplication}>
            Send Application
          </CustomButton>
        </Grid>
      </Grid>
    </div>
  );
}
